export default "__VITE_ASSET__bb532bdd__"